"use client";
// css
import styles from "./index.module.scss";
// view
import Image from "next/image";
import CategoryList from "./fragments/categoryList";
import CarouselImgList from "./fragments/carouselImgList";
//ts
import { useTranslations, useCurrentLocale } from "@/app/lib/LocaleProvider";
import { useEffect, useState } from "react";

export default function Sidebar() {
  const t = useTranslations();
  const lng = useCurrentLocale();
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [mounted, setMounted] = useState(false);

  // 检测是否为移动端
  useEffect(() => {
    setMounted(true);
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);

    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  // 避免 hydration 错误：在客户端挂载前不渲染
  if (!mounted) {
    return null;
  }

  return isMobile ? null : (
    <div className={styles.sidebar}>
      <div className={styles.welcome}>
        <div className={styles.welcomeTitleWrapper}>
          <div className={styles.welcomeTitle}>{t.sidebar.hello}</div>
          <Image
            className={styles.icon}
            src="/images/welcome.svg"
            height={30}
            width={30}
            alt=""
          />
        </div>
        {/* <div className={styles.desc}>{t.sidebar.desc}</div> */}
      </div>
      <div className={styles.listContainer}>
        <CategoryList />
      </div>
      <CarouselImgList />
    </div>
  );
}
